import { render, staticRenderFns } from "./AddTaxGroupComponent.vue?vue&type=template&id=83f8568c&"
import script from "./AddTaxGroupComponent.vue?vue&type=script&lang=js&"
export * from "./AddTaxGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports